import React, { useState } from 'react';
import { slide as Menu } from 'react-burger-menu';
import { NavLink, useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import './Menu.css';

const MobileMenu = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { user, userData, logout } = useUser();
  const navigate = useNavigate();

  const isFreeUser = userData?.plan === 'free' || !userData?.plan;
  const isPremiumUser = userData?.plan === 'premium' || userData?.plan === 'prem';

  const handleMenuClick = (path) => {
    setIsMenuOpen(false);
  };

  const handleLogout = async () => {
    try {
      setIsMenuOpen(false);

      // Pequeno delay para fechar o menu antes do logout
      setTimeout(async () => {
        const logoutSuccess = await logout();

        if (logoutSuccess) {
          // Forçar redirecionamento completo
          window.location.href = '/';
          // Prevenir qualquer comportamento de recarregamento automático
          setTimeout(() => {
            window.location.replace('/');
          }, 100);
        } else {
          // Fallback: redirecionar mesmo com erro
          window.location.href = '/';
        }
      }, 300);

    } catch (error) {
      console.error('Erro ao fazer logout:', error);
      // Fallback final
      window.location.href = '/';
    }
  };

  const handleUpgradeClick = () => {
    setIsMenuOpen(false);
    navigate('/upgrade');
  };

  const handleStateChange = (state) => {
    setIsMenuOpen(state.isOpen);
  };

  return (
    <Menu
      isOpen={isMenuOpen}
      onStateChange={handleStateChange}
      width={280}
      right={false} // ✅ REMOVIDO - AGORA ABRE DA ESQUERDA
      className="mobile-menu"
    >
      <div className="mobile-nav">
        <div className="menu-header">
          <h3>LotopimApp</h3>
          {isPremiumUser && <div className="premium-badge">⭐ Premium</div>}
          {isFreeUser && <div className="free-badge">👶 Free</div>}
        </div>

        <div className="menu-items-container">
          {/* Home */}
          <NavLink className="menu-item tooltip-container" to="/home" onClick={() => handleMenuClick('/home')}>
            <span className="menu-icon">🏠</span>
            <span className="menu-text">Início</span>
            <div className="tooltip">Página inicial</div>
          </NavLink>

          {/* Estratégias Free */}
          <div className="menu-section">
            <span className="section-label">🎯 ESTRATÉGIAS FREE</span>
            <NavLink className="menu-item tooltip-container" to="/7-8" onClick={() => handleMenuClick('/7-8')}>
              <span className="menu-icon">🔢</span>
              <span className="menu-text">7-8 (Par-Ímpar)</span>
              {/* ✅ BADGE GRÁTIS VERDE - APENAS PARA FREE */}
              {isFreeUser && <span className="free-green-badge">GRÁTIS</span>}
              <div className="tooltip">Esquema mais sorteado da Lotofácil</div>
            </NavLink>
          </div>

          {/* Estratégias Premium */}
          {isPremiumUser ? (
            <div className="menu-section">
              <span className="section-label premium">💎 ESTRATÉGIAS PREMIUM</span>
              <NavLink className="menu-item tooltip-container" to="/8-7" onClick={() => handleMenuClick('/8-7')}>
                <span className="menu-icon">🎯</span>
                <span className="menu-text">8-7 (Par-Ímpar)</span>
                <div className="tooltip">Conteúdo Premium!</div>
              </NavLink>
              <NavLink className="menu-item tooltip-container" to="/6-9" onClick={() => handleMenuClick('/6-9')}>
                <span className="menu-icon">🎯</span>
                <span className="menu-text">6-9 (Par-Ímpar)</span>
                <div className="tooltip">Conteúdo Premium!</div>
              </NavLink>
              <NavLink className="menu-item tooltip-container" to="/9-6" onClick={() => handleMenuClick('/9-6')}>
                <span className="menu-icon">🎯</span>
                <span className="menu-text">9-6 (Par-Ímpar)</span>
                <div className="tooltip">Conteúdo Premium!</div>
              </NavLink>
              <NavLink className="menu-item tooltip-container" to="/5-10" onClick={() => handleMenuClick('/5-10')}>
                <span className="menu-icon">🎯</span>
                <span className="menu-text">5-10 (Par-Ímpar)</span>
                <div className="tooltip">Conteúdo Premium!</div>
              </NavLink>
              <NavLink className="menu-item tooltip-container" to="/10-5" onClick={() => handleMenuClick('/10-5')}>
                <span className="menu-icon">🎯</span>
                <span className="menu-text">10-5 (Par-Ímpar)</span>
                <div className="tooltip">Conteúdo Premium!</div>
              </NavLink>
              <NavLink className="menu-item tooltip-container" to="/surpresinha" onClick={() => handleMenuClick('/surpresinha')}>
                <span className="menu-icon">🎲</span>
                <span className="menu-text">Surpresinha Premium</span>
                <div className="tooltip">Conteúdo Premium!</div>
              </NavLink>
            </div>
          ) : (
            <div className="menu-section">
              <span className="section-label locked">🔒 ESTRATÉGIAS PREMIUM</span>
              <div className="locked-items">
                <div className="locked-item tooltip-container" onClick={handleUpgradeClick}>
                  <span className="menu-icon">🎯</span>
                  <span className="menu-text">8-7 (Par-Ímpar)</span>
                  <span className="lock-icon">🔒</span>
                  <div className="tooltip">Conteúdo Premium!</div>
                </div>
                <div className="locked-item tooltip-container" onClick={handleUpgradeClick}>
                  <span className="menu-icon">🎯</span>
                  <span className="menu-text">6-9 (Par-Ímpar)</span>
                  <span className="lock-icon">🔒</span>
                  <div className="tooltip">Conteúdo Premium!</div>
                </div>
                <div className="locked-item tooltip-container" onClick={handleUpgradeClick}>
                  <span className="menu-icon">🎯</span>
                  <span className="menu-text">9-6 (Par-Ímpar)</span>
                  <span className="lock-icon">🔒</span>
                  <div className="tooltip">Conteúdo Premium!</div>
                </div>
                <div className="locked-item tooltip-container" onClick={handleUpgradeClick}>
                  <span className="menu-icon">🎯</span>
                  <span className="menu-text">5-10 (Par-Ímpar)</span>
                  <span className="lock-icon">🔒</span>
                  <div className="tooltip">Conteúdo Premium!</div>
                </div>
                <div className="locked-item tooltip-container" onClick={handleUpgradeClick}>
                  <span className="menu-icon">🎯</span>
                  <span className="menu-text">10-5 (Par-Ímpar)</span>
                  <span className="lock-icon">🔒</span>
                  <div className="tooltip">Conteúdo Premium!</div>
                </div>
                <div className="locked-item tooltip-container" onClick={handleUpgradeClick}>
                  <span className="menu-icon">🎲</span>
                  <span className="menu-text">Surpresinha Premium</span>
                  <span className="lock-icon">🔒</span>
                  <div className="tooltip">Conteúdo Premium!</div>
                </div>
              </div>
            </div>
          )}

          {/* Ferramentas */}
          <div className="menu-section">
            <span className="section-label">🛠️ FERRAMENTAS</span>
            <NavLink className="menu-item tooltip-container" to="/corrigir" onClick={() => handleMenuClick('/corrigir')}>
              <span className="menu-icon">📊</span>
              <span className="menu-text">Corrigir Jogos</span>
              {/* ✅ BADGE GRÁTIS VERDE ARREDONDADO */}
              {isFreeUser && <span className="free-green-badge">GRÁTIS</span>}
              <div className="tooltip">Verifique seus jogos da Lotofácil</div>
            </NavLink>
          </div>
        </div>

        {/* ✅ AÇÕES DO MENU */}
        <div className="menu-actions">
          {isFreeUser && (
            <button className="upgrade-cta tooltip-container" onClick={handleUpgradeClick}>
              <span className="menu-icon">💎</span>
              <span className="menu-text">Upgrade Premium</span>
              <div className="tooltip">Desbloqueie todas as estratégias!</div>
            </button>
          )}
          {user && (
            <button className="logout-btn tooltip-container" onClick={handleLogout}>
              <span className="menu-icon">🚪</span>
              <span className="menu-text">Sair</span>
              <div className="tooltip">Sair da conta</div>
            </button>
          )}
        </div>
      </div>
    </Menu>
  );
};

export default MobileMenu;